/**
 * Version type enum for flow model version history
 * Represents the different types of versions that can be created
 */
export enum VersionType {
  Published = 'Published',
  Saved = 'Saved',
  AutoSaved = 'AutoSaved'
}
